import { useAppSelector } from '#store/store.ts';

import { getLocale } from './langSlice';

const supportedManualLanguages = [
    'bg',
    'cz',
    'de',
    'dk',
    'ee',
    'en',
    'es',
    'fi',
    'fr',
    'gr',
    'hr',
    'hu',
    'it',
    'lt',
    'lv',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'se',
    'si',
    'sk',
];

export const useLocale = () => {
    return useAppSelector(getLocale);
};

export const useShortLocale = () => {
    const locale = useLocale();
    let language = (locale || 'en').split('-')[0].toLocaleLowerCase();
    if (!supportedManualLanguages.includes(language)) {
        language = 'en';
    }
    return language;
};
